var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12.676 11.632 4.744 1.538c.44.143.44.767 0 .91l-4.744 1.538a.48.48 0 0 0-.308.308L10.83 20.67a.478.478 0 0 1-.91 0l-1.538-4.744a.478.478 0 0 0-.307-.308L3.33 14.08a.478.478 0 0 1 0-.91l4.744-1.538a.477.477 0 0 0 .307-.307L9.92 6.58a.478.478 0 0 1 .91 0l1.538 4.744a.48.48 0 0 0 .308.307Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21 8.977h-2.656m1.328-1.329v2.657M15.688 3v3.984m1.992-1.992h-3.985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.995377efeb3a6f51d707e7018fc02039.svg";
export { ForwardRef as ReactComponent };